/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="20.06"
        height="17.97"
        viewBox="0 0 20.06 17.97"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M1.19 5.03a8.63 8.63 0 0 1 11.78-3.15 6.49 6.49 0 0 1 .7.46l.13.09-.59.81-.12-.09a6.41 6.41 0 0 0-.61-.4A7.62 7.62 0 1 0 16 7.29c0-.18-.11-.36-.18-.55l-.05-.14.94-.34v.14a5.1 5.1 0 0 1 .2.63 8.62 8.62 0 1 1-15.77-2Zm2.2 1.62a5.92 5.92 0 0 1 8-2.58c.19.13.44.29.6.41l.13.08-.57.83-.12-.09-.54-.36a4.91 4.91 0 1 0 2.6 3.29 2.47 2.47 0 0 0-.1-.29V7.8l.93-.37v.14a3.09 3.09 0 0 1 .14.43 5.92 5.92 0 0 1-5.77 7.26 5.75 5.75 0 0 1-2.67-.65 5.91 5.91 0 0 1-2.67-7.96Zm2.79.66a3.21 3.21 0 0 1 3.78-.9l.14.07-.41.91-.13-.06a2.17 2.17 0 0 0-1.66-.06 2.21 2.21 0 1 0 3 1.91v-.15l1-.07v.15a3.21 3.21 0 1 1-5.68-1.8Zm13.91-4.17a.48.48 0 0 0-.32-.41l-1.63-.62-.23-1.68a.52.52 0 0 0-.33-.4.5.5 0 0 0-.51.1l-2.5 2.31a.54.54 0 0 0-.16.34l-.12 1.72-6.1 4.56.6.8 6.1-4.56 1.67.31a.51.51 0 0 0 .38-.07l2.87-1.93a.5.5 0 0 0 .22-.47Zm-3.48 1.45-1.27-.24.06-1.32 1.65-1.52.15 1a.49.49 0 0 0 .31.4l1 .38Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'TargetWithArrowIcon';

export default Icon;
